export default __webpack_public_path__ + "static/media/20.2f31cfcf.jpg";